export default function Footer() {
  return (
    <footer id="footer" className="py-12 md:py-16 bg-background-50 border-t border-background-200/30">
      <div className="section-container px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <span className="text-2xl">🐱</span>
              <span className="font-heading text-xl text-foreground-100">夜猫电影院</span>
            </div>
            <p className="text-xs text-foreground-500 leading-relaxed">
              高清电视剧免费在线观看平台，每日同步更新最新剧集。古装都市悬疑甜宠全覆盖，秒播不卡顿，追剧神器。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-300 mb-4">快捷导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</a>
              <a href="#cards" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精选推荐</a>
              <a href="#ranking" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热播榜单</a>
              <a href="#updates" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">最新动态</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-300 mb-4">帮助支持</h4>
            <div className="flex flex-col gap-2">
              <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
              <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
              <a href="#about" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
              <a href="#features" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">平台优势</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-300 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-600">
              诚邀优质内容平台与品牌加入合作，共同为剧迷打造更好的追剧生态。
            </p>
          </div>
        </div>

        <div className="border-t border-background-200/30 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; 2026 夜猫电影院 - 电视剧大全免费在线观看 | 高清秒播不缓冲
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <span>电视剧大全</span>
            <span>最新电视剧</span>
            <span>热门剧集</span>
          </div>
        </div>
      </div>
    </footer>
  );
}